import React from "react";

const SvgCampaign = props => (
  <svg viewBox="0 0 215 215" {...props}>
    <path
      fill="currentColor"
      d="M181.5 65.3l-4.5 3.4c5.9 8.3 8.9 18.3 8.7 28.5.2 10.2-2.8 20.2-8.7 28.5l4.5 3.4c6.6-9.3 10-20.4 9.8-31.8.2-11.5-3.2-22.6-9.8-32z"
    />
    <path
      fill="currentColor"
      d="M194.4 51.8l-4.3 3.6c9.1 11 14.2 25.8 14.2 41.8s-4.9 30.4-13.8 41.4l4.3 3.5c9.7-11.9 15.1-27.9 15.1-44.9 0-17.3-5.5-33.4-15.5-45.4zm-34.9 18.9V25.8L72 66.3V55.9H22.3v12H4.9v59.7h17.4v10.9h11.4L54.3 195l23.7-8.6-17.3-48H72V128l87.5 40.6v-44.9c7.8-3.2 13.2-13.8 13.2-26.5s-5.4-23.3-13.2-26.5zm-149 51.2V73.5h11.8V122l-11.8-.1zM70.9 183l-13.2 4.8-17.9-49.4h15L70.9 183zm-4.5-50.2H27.9V61.5h38.5v71.3zm87.6 27.1l-82-38V72.5l82-38v125.4zm5.5-42.6V77.1c4.5 3.4 7.6 11.3 7.6 20.1s-3.1 16.7-7.6 20.1z"
    />
  </svg>
);

export default SvgCampaign;